"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_validator_1 = require("../create-validator");
var messages_1 = require("../messages");
exports.validOption = function (options, valueSelector, message) {
    var values = options.map(valueSelector);
    return create_validator_1.createValidator(function (v) { return values.indexOf(v) !== -1; }, message || messages_1.CHOOSE_OPTION);
};
